import { AssetDetail } from "@syla/shared/types/responses/GetAccountAssetsResponse";
import { GetAssetsResponse } from "@syla/shared/types/responses/GetAssetsResponse";
import axios from "axios";

export async function getAssets(filter?: string): Promise<AssetDetail[]> {
  const response = await axios.get<GetAssetsResponse>(`/assets`, {
    params: {
      filter,
    },
  });
  return response.data.assets;
}
